import React, { useState, useRef, useEffect } from "react";
import "./styles.css";
import ReactDom from "react-dom";
import { Encriptar } from "@renedelangel/helpers";
import PopUpAlert from "../PopUpAlerta";
import { urlServidor } from "helpers";
import LoaderLogoSoftwone from "_layout/assets/svg/Animaciones/logoSoftwone";

const { DescriptarToken } = Encriptar;

export default function PopUpCotiza(props) {
    const seedToken = "c29mdHdvbmVAc2VndW1leA==";

    let { openPopUpCotizar } = props;

    const [datosCotizar, setDatosCotizar] = useState({
        nombre: "",
        correoElectronico: "",
        telefono: "",
        servicio: "",
        mensaje: ""
    });

    const [textoAlert, setTextoAlert] = useState({
        titulo: "",
        mensaje: ""
    });

    const [openAlert, setOpenAlert] = useState(false);
    const [loading, setLoading] = useState(false);

    const nombreRef = useRef(null);
    const correoElectronicoRef = useRef(null);
    const telefonoRef = useRef(null);
    const servicioRef = useRef(null);
    const mensajeRef = useRef(null);

    /*----------------------------------------------------------------*/

    const delay = ms => new Promise(resolve => setTimeout(resolve, ms));

    /*----------------------------------------------------------------*/
    const regexpCorreo = /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/;
    const rgxPassword = /^(?=(.*[\d]){1,})(?=(.*[a-zñ]){1,})(?=(.*[A-ZÑ]){1,})(?=(.*[@#$%¡!*=<>()|¿?&-]){1,})(?:[\da-zA-ZÑñ=@#$%¡!*<>()|¿?&-]){8,30}$/;
    const rgxPhoneNumber = /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/;

    /*----------------------------------------------------------------*/

    function handleValidaciones({
        nombre,
        correoElectronico,
        telefono,
        servicio,
        mensaje
    }) {
        let error;
        let validaciones = [
            {
                condicion: nombre == null || nombre == "",
                ref: nombreRef,
                keyError: "nombre",
                mensajeError: "Debe indicar su nombre"
            },
            {
                condicion: correoElectronico == null || correoElectronico == "",
                ref: correoElectronicoRef,
                keyError: "correoElectronico",
                mensajeError: "Debe indicar un correo"
            },
            {
                condicion: !regexpCorreo.test(correoElectronico),
                ref: correoElectronicoRef,
                keyError: "correoElectronico",
                mensajeError: "Debe indicar un correo valido"
            },
            {
                condicion: telefono == null || telefono == "",
                ref: telefonoRef,
                keyError: "telefono",
                mensajeError: "Debe indicar un telefono"
            },
            {
                condicion: !rgxPhoneNumber.test(telefono),
                ref: telefonoRef,
                keyError: "telefono",
                mensajeError: "Debe indicar un telefono valido"
            },
            {
                condicion: servicio == null || servicio == "",
                ref: servicioRef,
                keyError: "servicio",
                mensajeError: "Debe seleccionar un servicio"
            },
            {
                condicion: mensaje == null || mensaje == "",
                ref: mensajeRef,
                keyError: "mensaje",
                mensajeError: "Agregue una pequeña descripción para poder brindarle una mejor atención"
            }
        ];

        validaciones.forEach(({ condicion, ref, mensajeError }) => {
            if (error) return;
            if (condicion) {
                /* alert(mensajeError); */

                setTextoAlert({
                    titulo: "Revisa tus datos",
                    mensaje: mensajeError
                });
                setOpenAlert(true);

                ref.current.focus();
                ref.current.select();
                error = true;
            }
        });

        if (error) return error;
    }
    /*----------------------------------------------------------------*/
    function ftEnviarCorreoCotizacion() {
        async function ftEnviarCorreoCotizacion() {
            setLoading(true);
            let {
                nombre,
                correoElectronico,
                telefono,
                servicio,
                mensaje
            } = datosCotizar;

            let error = handleValidaciones({
                nombre,
                correoElectronico,
                telefono,
                servicio,
                mensaje
            });

    
            if (error) {
                setLoading(false);
                return error;}
            await enviarCorreo();
            
        }
        ftEnviarCorreoCotizacion();
    }
    /*----------------------------------------------------------------*/

    async function enviarCorreo() {
        const tokenTemp = Encriptar.GenerarToken({
            data: { usuario: "temporal" },
            expiresIn: "1m",
            seed: seedToken
        });

        let datosCompletos = [datosCotizar];
        let myHeaders = new Headers();
        myHeaders.append("token", tokenTemp);
        myHeaders.append("mimeType", "multipart/form-data");

        let formdata = new FormData();
        formdata.append("datos", JSON.stringify(datosCompletos));

        let requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: formdata
        };

        await fetch(
            `${urlServidor}/service/email/cotizacionServicios`,
            requestOptions
        )
            .then(response => {
                if (!response.ok) return response.json();
                setLoading(false);
                setTextoAlert({
                    titulo: "Envio exitoso",
                    mensaje: "El correo se ha enviado de forma correcta."
                });
                setOpenAlert(true);
                stop();
            })
            .catch(error => {
                setLoading(false);
                console.error("Error:", error);
            });
    }
    /*----------------------------------------------------------------*/
    async function stop() {
        setDatosCotizar({
            nombre: "",
            correoElectronico: "",
            telefono: "",
            servicio: "",
            mensaje: ""
        });
        await delay(3000);
        setOpenAlert(false);
        openPopUpCotizar(false);
    }
    /*----------------------------------------------------------------*/
    function handleChange(e) {
        const { name, value } = e.target;
        setDatosCotizar(prevState => {
            return {
                ...prevState,
                [name]: value
            };
        });
    }

    /*----------------------------------------------------------------*/

    let {
        nombre,
        correoElectronico,
        telefono,
        servicio,
        mensaje
    } = datosCotizar;

    return ReactDom.createPortal(
        <>
            <div
                className="contenedorGeneralPopUpCotizar"
                onClick={() => {
                    openPopUpCotizar(false);
                }}
            >
                <div
                    className="contenedorInternoPopUpCotizar"
                    onClick={e => {
                        e.stopPropagation();
                    }}
                >
                    <div className="tituloPopUpCotizar">
                        <h1>COTIZAR UN SERVICIO</h1>
                    </div>

                    <input
                        ref={nombreRef}
                        type="text"
                        placeholder="Nombre Completo"
                        name="nombre"
                        value={nombre}
                        onChange={e => {
                            handleChange(e);
                        }}
                    ></input>

                    <input
                        ref={correoElectronicoRef}
                        type="text"
                        placeholder="Correo electrónico"
                        name="correoElectronico"
                        value={correoElectronico}
                        onChange={e => {
                            handleChange(e);
                        }}
                    ></input>

                    <input
                        ref={telefonoRef}
                        type="text"
                        placeholder="Teléfono"
                        name="telefono"
                        value={telefono}
                        onChange={e => {
                            handleChange(e);
                        }}
                    ></input>

                    <select
                        ref={servicioRef}
                        type="text"
                        name="servicio"
                        value={servicio}
                        onChange={e => {
                            handleChange(e);
                        }}
                    >
                        <option value="" disabled selected>
                            Servicio que desea cotizar
                        </option>

                        <option value="Consultoria">Consultoria</option>

                        <option value="Diseño Web">Diseño Web</option>

                        <option value="Desarrollo de Aplicaciones">
                            Desarrollo de Aplicaciones
                        </option>

                        <option value="Hosting">Hosting</option>

                        <option value="Marketing Digital">
                            Marketing Digital
                        </option>
                    </select>

                    <textarea
                        ref={mensajeRef}
                        type="text"
                        placeholder="Información Adicional"
                        name="mensaje"
                        value={mensaje}
                        onChange={e => {
                            handleChange(e);
                        }}
                    ></textarea>

                    <button
                        onClick={() => {
                            ftEnviarCorreoCotizacion();
                        }}
                    >
                        Enviar
                    </button>
                </div>
            </div>
            {openAlert ? (
                <PopUpAlert
                    titulo={textoAlert.titulo}
                    mensaje={textoAlert.mensaje}
                    open={setOpenAlert}
                />
            ) : (
                <></>
            )}

            {
                loading ? 
                <LoaderLogoSoftwone/> : 
                <></>
            }
        </>,
        document.getElementById("login")
    );
}
